import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=cd207cfa&scoped=true"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=cd207cfa&prod&scoped=true&lang=css"
import style1 from "./FormLabel.vue?vue&type=style&index=1&id=cd207cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd207cfa",
  null
  
)

export default component.exports